module["exports"] = [
  "United States",
  "United States of America",
  "USA"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_US/address/default_country.js
// module id = 1191
// module chunks = 1